const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

export const getMessages = async (coachClientId, { before, limit } = {}) => {
  const params = new URLSearchParams();
  if (before) params.set('before', before);
  if (limit) params.set('limit', String(limit));
  const qs = params.toString();

  const response = await fetch(
    `${API_URL}/messages/${coachClientId}${qs ? `?${qs}` : ''}`,
    { headers: getAuthHeaders() }
  );
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to fetch messages');
  }
  return response.json();
};

export const sendMessage = async (coachClientId, body) => {
  const response = await fetch(`${API_URL}/messages/${coachClientId}`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ body }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to send message');
  }
  return response.json();
};

export const getUnreadCounts = async () => {
  const response = await fetch(`${API_URL}/messages/unread-counts`, {
    headers: getAuthHeaders(),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to fetch unread counts');
  }
  return response.json();
};
